<template>
  <component
    :is="tag"
    v-on="$listeners"
    class="element-chat-left"
  > 
  <div :class="chat_active ? 'badge-active' : ''"></div>
    <b-avatar
      size="42"
      :src="verifyAsset(chat.user.avatar)"
      class="badge-minimal"
      :badge="chat.is_legacy"
      badge-variant="info"
    />
    <div class="chat-info">
      <h5 class="mb-0">
        {{ chat.user.first_name }} {{ chat.user.last_name }} 
        <b-badge
          v-if="chat.is_legacy"
          variant="info"
          class="badge-legacy"
        >
          Legacy
        </b-badge>
      </h5>
      <p class="card-text text-truncate d-block">
        {{ getLastMessageText() }}
      </p>
    </div>
    <div
      class="chat-meta text-nowrap"
    > 
      <small class="float-right mb-25 chat-time">
        {{ chat.lastMessage && chat.lastMessage.sended_at ? formatDateToMonthShort(chat.lastMessage.sended_at, { dateFormat: 'numeric' }) : '' }}</small>
      <div
        v-if="chat.unseenMsgs > 0"
        pill
        class="dot-color-unmessages"
      ></div>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge, } from 'bootstrap-vue'
import { formatDateToMonthShort } from '@core/utils/filter'
import { getDateLocal } from '@/libs/utils/times';
import { verifyAsset, } from '@/libs/utils/urls'

export default {
  name: 'elementChat',
  components: {
    BAvatar,
    BBadge,

  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    chat: {
      type: Object,
      required: true,
    },
    chat_active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getDateLocal,
      verifyAsset,
    }
  },
  created() {
  },
  methods: {
    getLastMessageText() {
      if (this.chat.lastMessage) {
        if (this.chat.lastMessage.type_message === 'file')
          return 'Te han enviado un archivo'
  
        return this.chat.lastMessage.message
      }
      return "Escribe el primer mensaje";
    }
  },
  setup() {
    return { formatDateToMonthShort }
  },
}
</script>

<style scoped>
.dot-color-unmessages {
  height: 16px;
  width: 16px;
  background-color: #00a05a;
  border-radius: 10em;
}
@media(max-width: 900px) {
  .chat-info,
  .chat-meta {
    display: none !important;
  }
}
.chat-meta {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
}
.chat-info {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}
.chat-info h5,
.chat-info p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.badge-legacy {
  font-size: 9px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 6px;
  line-height: 1;
  letter-spacing: 0.3px;
  color: white;
}
.badge-active {
  width: 5px;
  height: 100%;
  background: linear-gradient(to bottom, #0094fc, #1efdc6);
  position: absolute;
  left: 0;
  top: 0;
}
.element-chat-left {
  position: relative;
  background-color: #F8F9FA;
  border-bottom: 1px solid #e9ecef;
  border-right: 1px solid #e9ecef;
}
.chat-application .sidebar-content .chat-user-list-wrapper li {
  padding: 16px;
}
</style>
